import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilNgModule } from '@innovation-os-ng/ui/utils';
import { TranslateModule, TranslateRegistry } from '@itonics/ngx-translate-simple';
import { Ui2DatepickerRangeComponent } from './components/datepicker-range/ui2-datepicker-range.component';
import { Ui2DatepickerSingleComponent } from './components/datepicker-single/ui2-datepicker-single.component';
import { Ui2DatepickerQuickOptionsComponent } from './components/ui2-datepicker-quick-options/ui2-datepicker-quick-options.component';
import { Ui2DatepickerComponent } from './components/ui2-datepicker.component';
import { de } from './i18n/de';
import { en } from './i18n/en';

@NgModule({
  declarations: [Ui2DatepickerComponent, Ui2DatepickerSingleComponent, Ui2DatepickerRangeComponent, Ui2DatepickerQuickOptionsComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    TranslateModule,
    UtilNgModule,
    ReactiveFormsModule
  ],
  exports: [Ui2DatepickerComponent],
  providers: [DatePipe]
})
export class Ui2DatepickerModule {
  constructor(private translateRegistry: TranslateRegistry) {
    this.translateRegistry.registerLoader((lang) => Promise.resolve({ en, de }[lang] || en));
  }
}
